import React from "react";
import LegalDoc from "./LegalDoc";

export default function Takedown() {
  const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const url = process.env.REACT_APP_LEGAL_TAKEDOWN_URL || (apiBase ? `${apiBase}/public/legal/content-takedown` : "https://storage.googleapis.com/hangrong-legal/legal/content-takedown-latest.md");
  return <LegalDoc title="Content & Takedown Policy" url={url} />;
}
